import React from 'react';
import { styled } from '@linaria/react';
import { equals, intersection, last } from 'ramda';
import { Text } from '@daedalus/atlas/Text';
import { Offer } from '@daedalus/core/src/offer/types/offer';
import { useGetRoomOfferLabels } from '../useGetRoomOfferLabels';
const RoomLabelsItem = /*#__PURE__*/styled('span')({
  name: "RoomLabelsItem",
  class: "rr98vl6",
  propsAsIs: false
});
const Dot = /*#__PURE__*/styled('span')({
  name: "Dot",
  class: "dv9tl71",
  propsAsIs: false
});
interface Props {
  offers: Offer[];
}
export const PrimaryRoomOfferLabels = ({
  offers
}: Props) => {
  // for SB we'll have two offers, for regular offer - only one
  const offer1Labels = useGetRoomOfferLabels({
    offer: offers?.[0]
  });
  const offer2Labels = useGetRoomOfferLabels({
    offer: offers?.[1]
  });
  const labels = offer2Labels.length > 0 ? intersection(offer1Labels, offer2Labels) : offer1Labels;
  return <Text variant="bodyXS" colorPath="content.featured.c500">
      {labels.map(label => <RoomLabelsItem key={label}>
          {label}
          {!equals(last(labels), label) && <Dot as="span">·</Dot>}
        </RoomLabelsItem>)}
    </Text>;
};

require("./PrimaryRoomOfferLabels.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PrimaryRoomOfferLabels.tsx");